<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'수령 일괄 업로드'"
      :modal="true"
      :width="'500px'"
      style="display:none;"
      @close="onClickClose"
  >
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <ul>
            <li class="mgt10">
                <span>1. <b>샘플 파일을 다운로드</b> 후 내용을 입력 후 <b>파일을 업로드</b> 해 주세요.
                <br>2. 양식에 맞지않는 파일인 경우 정상 진행되지 않습니다.
                <br>3. 정상 등록되지 않은 항목은 다운로드가 가능하며 수정 후 재등록 해 주세요 </span>
              <div class="box_flex mgt10">
                <button type="button" class="mid_btn mr5 w30" @click="sampleDownload" ><span><span class="k-icon k-i-download"></span>수령 샘플 파일</span></button>
              </div>
            </li>
          </ul>
          <div class="messagepop_form_wrap mgt20">
            <div class="mp_form">
              <dd>
                <kendo-upload
                    ref="upload"
                    name="files"
                    :select="fnOnSelectFile"
                    :multiple="false"
                    :files="file"
                    :localization-select="'파일 업로드'"
                    :show-file-list="true"
                    :async-auto-upload="false"
                    :validation-allowed-extensions='[".xlsx", ".xls"]'
                    style="'width: 300px;'">
                </kendo-upload>
              </dd>
            </div>
          </div>
          <div class="msg_green mgt10">
            <span v-if="isReadyToUpload">양식에 맞는 파일입니다.  중복 및 오류는 업로드  이후 확인이 가능합니다</span>
          </div>
          <div class="k-text-center mgt30">
            <button type="button" id="buttonUpload" class="mid_btn mr5 orange" @click="fnExecUpload">업로드</button>
            <button type="button" id="buttonCancel" class="mid_btn" @click="$emit('onChange'); $refs.kendoWindowRef.kendoWidget().close();">취소</button>
          </div>
        </div>
      </div>
    </template>
    <excel-upload-result-window
        ref="excelUploadResultWindowRef"
        v-bind:data="excelUploadResult"
        v-bind:file="workbookData"
        @onChange="$emit('onChange')"
    >
    </excel-upload-result-window>
  </kendo-window>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'

import EtnersCommonUtil from '@/common/etners.common.util'
import $ from 'jquery'
import * as XLSX from "xlsx"
import EtnersLogisticsUtil from '@/common/etners.logistics.util'
import ExcelUploadResultWindow from '@/components/receive/excelUploadResultWindow.vue'
import app from '@/main'

export default {
  name: 'receiveExcelUploadWindow',
  components: { ExcelUploadResultWindow },
  methods: {
    fnOnSelectFile: function(e) {
      const vm = this
      const fileInfo = e.files[0]
      vm.uploadDataArray = []

      app.$Progress.plus()
      setTimeout(function() {
        const raw = fileInfo.rawFile
        const reader = new FileReader()
        const fileList = e.sender._module.element.find('ul')

        reader.onloadend = function(e) {
          let data = e.target.result
          let workbook = XLSX.read(data, {
            type: 'binary'
          })
          let successBool = true

          vm.workbookData = workbook

          workbook.SheetNames.forEach((sheetName) => {
            if (sheetName === '수령 양식') {
              const rowJson = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName])

              if (rowJson.length < 5) {
                successBool = false
                kendo.alert('데이터가 존재하지 않습니다.')
                return false
              }
              if (rowJson.length >= 1004) {
                successBool = false
                kendo.alert('1000건 이상은 업데이트 할 수 없습니다.')
                return false
              }

              for (let i = 4; i < rowJson.length; i++) {
                if (rowJson[i]['_EMPTY_1'] === undefined) {
                  let status = rowJson[i]['진행 상태']
                  let terrorSignScn = rowJson[i]['상태 여부']
                  let contents = rowJson[i]['비고']
                  let receiveScn = rowJson[i]['취급 구분']
                  let shpcScn = rowJson[i]['특송사']
                  let blNo = rowJson[i]['운송장 번호']
                  let location = rowJson[i]['사업장 / 거점 / 코스']
                  let receiveDept = rowJson[i]['수신 부서']
                  let receiveNm = rowJson[i]['수신']
                  let receiveTel = rowJson[i]['전화 번호']
                  let receiveSabun = rowJson[i]['사원 번호']
                  let receiveEmail = rowJson[i]['이메일']
                  let executiveYn = rowJson[i]['임원 여부']
                  let secretaryNm = rowJson[i]['비서 이름']
                  let secretaryEmail = rowJson[i]['비서 이메일']
                  let sendNm = rowJson[i]['발신']
                  let receiveAreaScn = rowJson[i]['수신 회사']
                  let lockerId = rowJson[i]['보관 위치']
                  let qty = rowJson[i]['수량']
                  let etcScn = rowJson[i]['구분']

                  // 최종 입력 값
                  let inputObj = {
                    status            :  EtnersCommonUtil.isNotEmpty(status)            ? (status.toString().trim().substring(0, 2) === '02' ? '98'
                                                                                          : status.toString().trim().substring(0, 2))                          : '',
                    terrorSignScn     :  EtnersCommonUtil.isNotEmpty(terrorSignScn)     ? terrorSignScn.toString().trim().substring(0, 2)                      : '',
                    contents          :  EtnersCommonUtil.isNotEmpty(contents)          ? contents.toString().trim()                                           : '',
                    receiveScn        :  EtnersCommonUtil.isNotEmpty(receiveScn)        ? receiveScn.toString().trim().substring(0, 2)                         : '',
                    shpcScn           :  EtnersCommonUtil.isNotEmpty(shpcScn)           ? shpcScn.toString().trim().substring(0, 2)                            : '',
                    blNo              :  EtnersCommonUtil.isNotEmpty(blNo)              ? blNo.toString().trim()                                               : '',
                    facility          :  EtnersCommonUtil.isNotEmpty(location)          ? location.toString().trim().substring(0, 2)                           : '',
                    area              :  EtnersCommonUtil.isNotEmpty(location)          ? location.toString().trim().substring(0, 4)                           : '',
                    course            :  EtnersCommonUtil.isNotEmpty(location)          ? location.toString().trim().substring(0, 6)                           : '',
                    receiveDept       :  EtnersCommonUtil.isNotEmpty(receiveDept)       ? receiveDept.toString().trim()                                        : '',
                    receiveNm         :  EtnersCommonUtil.isNotEmpty(receiveNm)         ? receiveNm.toString().trim()                                          : '',
                    receiveTel        :  EtnersCommonUtil.isNotEmpty(receiveTel)        ? receiveTel.toString().replace(/-/gi,"").trim()  : '',
                    receiveSabun      :  EtnersCommonUtil.isNotEmpty(receiveSabun)      ? receiveSabun.toString().trim()                                       : '',
                    receiveEmail      :  EtnersCommonUtil.isNotEmpty(receiveEmail)      ? receiveEmail.toString().trim()                                       : '',
                    executiveYn       :  EtnersCommonUtil.isNotEmpty(executiveYn)       ? executiveYn.toString().trim().substring(executiveYn.length - 1)      : '',
                    secretaryNm       :  EtnersCommonUtil.isNotEmpty(secretaryNm)       ? secretaryNm.toString().trim()                                        : '',
                    secretaryEmail    :  EtnersCommonUtil.isNotEmpty(secretaryEmail)    ? secretaryEmail.toString().trim()                                     : '',
                    sendNm            :  EtnersCommonUtil.isNotEmpty(sendNm)            ? sendNm.toString().trim()                                             : '',
                    receiveAreaScn    :  EtnersCommonUtil.isNotEmpty(receiveAreaScn)    ? receiveAreaScn.toString().trim().substring(0, 2)                     : '',
                    lockerId          :  EtnersCommonUtil.isNotEmpty(lockerId)          ? lockerId.toString().trim().substring(0, 2).padStart(5,'0')           : '',
                    qty               :  EtnersCommonUtil.isNotEmpty(qty)               ? qty.toString().trim()                                                : '',
                    etcScn            :  EtnersCommonUtil.isNotEmpty(etcScn)            ? etcScn.toString().trim().substring(0, 2)                             : '',
                  }

                  const excelLineMessage = '<br>엑셀 줄번호(' + (i + 2) + ') : '

                  // 필수 값 입력 체크 수령시
                  if (inputObj.status === '01' ) {
                    if (EtnersCommonUtil.isEmpty(inputObj.terrorSignScn)) {
                      kendo.alert(excelLineMessage + '상태여부를 선택해 주세요')
                      successBool = false
                      return
                    }
                    if (inputObj.terrorSignScn !== '01' && EtnersCommonUtil.isEmpty(inputObj.contents)) {
                      kendo.alert(excelLineMessage + '비고를 입력해 주세요')
                      successBool = false
                      return
                    } else if(inputObj.contents.length > 100){
                      kendo.alert(excelLineMessage + '비고는 100자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.receiveScn)) {
                      kendo.alert(excelLineMessage + '취급 구분을 선택해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.shpcScn)) {
                      kendo.alert(excelLineMessage + '특송사를 선택해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.blNo)) {
                      kendo.alert(excelLineMessage + '운송장 번호를 입력해주세요.')
                      successBool = false
                      return
                    } else if (!EtnersCommonUtil.isBlNo(inputObj.blNo)) {
                      kendo.alert(excelLineMessage + '운송장 번호는 영어와 숫자만 입력해주세요.')
                      successBool = false
                      return
                    } else if(inputObj.blNo.length > 50){
                      kendo.alert(excelLineMessage + '운송장 번호는 50자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.facility)) {
                      kendo.alert(excelLineMessage + '사업장 / 거점 / 코스를 선택 해주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.area)) {
                      kendo.alert(excelLineMessage + '사업장 / 거점 / 코스를 선택 해주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.course)) {
                      kendo.alert(excelLineMessage + '코스를 선택해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.receiveDept)) {
                      kendo.alert(excelLineMessage + '수신부서를 입력해 주세요')
                      successBool = false
                      return
                    } else if(inputObj.receiveDept.length > 50){
                      kendo.alert(excelLineMessage + '수신부서는 50자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.receiveNm)) {
                      kendo.alert(excelLineMessage + '수신인을 입력해 주세요')
                      successBool = false
                      return
                    } else if(inputObj.receiveNm.length > 20){
                      kendo.alert(excelLineMessage + '수신인은 20자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.receiveTel)) {
                      kendo.alert(excelLineMessage + '수신자 전화번호를 입력해 주세요')
                      successBool = false
                      return
                    } else if (!EtnersLogisticsUtil.isTelNum(inputObj.receiveTel)) {
                      kendo.alert(excelLineMessage + '전화 번호를 형식에 맞게 입력해 주세요.')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.receiveSabun)) {
                      kendo.alert(excelLineMessage + '수신자 사번을 입력해 주세요')
                      successBool = false
                      return
                    } else if (!EtnersLogisticsUtil.isValidSabun(inputObj.receiveSabun)) {
                      kendo.alert(excelLineMessage + '수신자 사번을 형식에 맞게 입력해 주세요.')
                      successBool = false
                      return
                    } else if(inputObj.receiveSabun.length > 20){
                      kendo.alert(excelLineMessage + '수신자 사번은 20자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.receiveEmail) || !EtnersLogisticsUtil.isEmailDomainAllowed(inputObj.receiveEmail)) {
                      kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(excelLineMessage + "수신인"))
                      successBool = false
                      return
                    } else if(inputObj.receiveEmail.length > 50){
                      kendo.alert(excelLineMessage + '수신인 메일은 50자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (inputObj.executiveYn === 'Y') {
                      if (EtnersCommonUtil.isEmpty(inputObj.secretaryNm)) {
                        kendo.alert(excelLineMessage + '비서 이름을 입력해 주세요')
                        successBool = false
                        return
                      } else if(inputObj.secretaryNm.length > 20){
                        kendo.alert(excelLineMessage + '비서 이름은 20자 이내로 입력해 주세요')
                        successBool = false
                        return
                      }
                      if (EtnersCommonUtil.isEmpty(inputObj.secretaryEmail) || !EtnersLogisticsUtil.isEmailDomainAllowed(inputObj.secretaryEmail)) {
                        kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(excelLineMessage + "비서"))
                        successBool = false
                        return
                      } else if(inputObj.secretaryEmail.length > 50){
                        kendo.alert(excelLineMessage + '비서 메일은 50자 이내로 입력해 주세요')
                        successBool = false
                        return
                      }
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.sendNm)) {
                      kendo.alert(excelLineMessage + '발신자 명을 입력해 주세요')
                      successBool = false
                      return
                    } else if(inputObj.sendNm.length > 20){
                      kendo.alert(excelLineMessage + '발신자 명은 20자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.lockerId)) {
                      kendo.alert(excelLineMessage + '보관 위치를 선택해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.qty)) {
                      kendo.alert(excelLineMessage + '수량을 입력해 주세요')
                      successBool = false
                      return
                    } else if (!EtnersLogisticsUtil.isPositiveInteger(inputObj.qty)) {
                      kendo.alert(excelLineMessage + '수량은 1이상의 숫자를 입력 해주세요.')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.etcScn)) {
                      kendo.alert(excelLineMessage + '구분을 선택해 주세요')
                      successBool = false
                      return
                    }
                  }
                  // 필수 값 입력 체크 반송시
                  if (inputObj.status === '98' ) {
                    if (EtnersCommonUtil.isEmpty(inputObj.terrorSignScn)) {
                      kendo.alert(excelLineMessage + '상태여부를 선택해 주세요')
                      successBool = false
                      return
                    }
                    if (inputObj.terrorSignScn === "01" ) {
                      kendo.alert(excelLineMessage + '반송시 상태 여부를 무로 지정할 수 없습니다.')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.contents)) {
                      kendo.alert(excelLineMessage + '비고를 입력해 주세요')
                      successBool = false
                      return
                    } else if(inputObj.contents.length > 100){
                      kendo.alert(excelLineMessage + '비고는 100자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.receiveScn)) {
                      kendo.alert(excelLineMessage + '취급 구분을 선택 해주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.shpcScn)) {
                      kendo.alert(excelLineMessage + '특송사를 선택해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.blNo)) {
                      kendo.alert(excelLineMessage + '운송장 번호를 입력해주세요.')
                      successBool = false
                      return
                    } else if (!EtnersCommonUtil.isBlNo(inputObj.blNo)) {
                      kendo.alert(excelLineMessage + '운송장 번호는 영어와 숫자만 입력해주세요.')
                      successBool = false
                      return
                    } else if(inputObj.blNo.length > 50){
                      kendo.alert(excelLineMessage + '운송장 번호는 50자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isEmpty(inputObj.qty)) {
                      kendo.alert(excelLineMessage + '수량을 입력해 주세요')
                      successBool = false
                      return
                    } else if (!EtnersLogisticsUtil.isPositiveInteger(inputObj.qty)) {
                      kendo.alert(excelLineMessage + '수량은 1이상의 숫자를 입력 해주세요.')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isNotEmpty(inputObj.receiveDept) && inputObj.receiveDept.length > 50){
                      kendo.alert(excelLineMessage + '수신부서는 50자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isNotEmpty(inputObj.receiveNm) && inputObj.receiveNm.length > 20){
                      kendo.alert(excelLineMessage + '수신인은 20자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isNotEmpty(inputObj.receiveSabun) && inputObj.receiveSabun.length > 20){
                      kendo.alert(excelLineMessage + '수신자 시번은 20자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isNotEmpty(inputObj.receiveEmail) && !EtnersLogisticsUtil.isEmailDomainAllowed(inputObj.receiveEmail)) {
                      kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(excelLineMessage + "수신인"))
                      successBool = false
                      return
                    } else if(EtnersCommonUtil.isNotEmpty(inputObj.receiveSabun) && inputObj.receiveEmail.length > 50){
                      kendo.alert(excelLineMessage + '수신인 메일은 50자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isNotEmpty(inputObj.secretaryNm) && inputObj.secretaryNm.length > 20){
                      kendo.alert(excelLineMessage + '비서 이름은 20자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isNotEmpty(inputObj.secretaryEmail) && !EtnersLogisticsUtil.isEmailDomainAllowed(inputObj.secretaryEmail)) {
                      kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(excelLineMessage + "수신인"))
                      successBool = false
                      return
                    } else if(EtnersCommonUtil.isNotEmpty(inputObj.secretaryEmail) && inputObj.secretaryEmail.length > 50){
                      kendo.alert(excelLineMessage + '비서 메일은 50자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                    if (EtnersCommonUtil.isNotEmpty(inputObj.sendNm) && inputObj.sendNm.length > 20){
                      kendo.alert(excelLineMessage + '발신자 명은 20자 이내로 입력해 주세요')
                      successBool = false
                      return
                    }
                  }
                  // 취급구분 별 특송사 매칭 여부 판단
                  if (['01', '02', '03', '04', '05', '06', '07'].includes(inputObj.receiveScn) && inputObj.shpcScn !== '08'){
                      kendo.alert(excelLineMessage + '취급 구분에 맞지 않는 특송사가 지정되었습니다.')
                      successBool = false
                      return
                  }
                  if (inputObj.receiveScn === '08' && inputObj.shpcScn !== '09'){
                      kendo.alert(excelLineMessage + '취급 구분에 맞지 않는 특송사가 지정되었습니다.')
                      successBool = false
                      return
                  }
                  if (inputObj.receiveScn === '09' && !['01', '02', '03', '04', '05', '06', '07'].includes(inputObj.shpcScn)){
                      kendo.alert(excelLineMessage + '취급 구분에 맞지 않는 특송사가 지정되었습니다.')
                      successBool = false
                      return
                  }
                  vm.uploadDataArray.push(inputObj)
                }
              } // end of for loop
            }
            // 업로드 실패시 array 및 fileList 제거
            if (successBool === false) {
              vm.removeFileList(fileList)
              app.$Progress.minus()
            }
          })
          //엑셀 양식이 다른 case(시트에 진입 x)
          if (successBool === true && vm.uploadDataArray.length === 0) {
            app.$Progress.minus()
            kendo.alert('샘플 엑셀양식과 다른 엑셀 파일입니다. 파일을 확인해주세요.')
            vm.removeFileList(fileList)
            return false
          } else if (successBool === true) {
            // 업로드 가능 상태
            vm.isReadyToUpload = true
            app.$Progress.minus()
          }
        }
        reader.readAsBinaryString(raw)
      })
    },

    fnExecUpload: function(e) {
      const vm = this
      const fileList = e.target.parentNode.parentNode.querySelector('.k-upload-sync ul')

      if (vm.uploadDataArray.length === 0) {
        kendo.alert('업로드한 자료가 없습니다.')
        return false
      }

      kendo.confirm('수령 ' + vm.uploadDataArray.length + '건을 업로드 하시겠습니까?').done(function() {
        let params = {
          loginUserToken: vm.loginUserToken,
          receiveInfo: vm.uploadDataArray,
        }
        let buttonUploadElem = document.querySelector('#buttonUpload')
        buttonUploadElem.setAttribute('disabled', 'disabled')

        /**
         * 1. 데이터 업로드 API 호출
         */
        ApiUtil.post(`${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/receive/receiveExcelUpload.json`, params).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터가 정상적으로 처리되지 않았습니다.')
            vm.removeFileList(fileList)
            buttonUploadElem.removeAttribute("disabled")
            return false
          }
          if (response.data.resultStatus.messageCode !== '2000') {
            kendo.alert(response.data.resultStatus.messageText)
            vm.removeFileList(fileList)
            buttonUploadElem.removeAttribute("disabled")
            return false
          }
          let resultData = response.data.resultData
          buttonUploadElem.removeAttribute("disabled")
          if(resultData.boolResult === false){
            vm.excelUploadResult = resultData
            vm.uploadResult()
            vm.removeFileList(fileList)
            vm.$refs.kendoWindowRef.kendoWidget().close()
            return false
          }
          else{
            vm.excelUploadResult = resultData
            vm.removeFileList(fileList)
            vm.$refs.kendoWindowRef.kendoWidget().close()
            vm.uploadResult()
          }
        })
      })
    },
    removeFileList: function(fileList) {
      const vm = this
      vm.uploadDataArray = []
      if (!!fileList) {
        fileList.remove()
      }
    },
    sampleDownload(){
      window.location = `${ApiConfig.eklDomain}/invariable/files/logistics_receive_excel_upload_form.xlsx`
    },
    uploadResult(){
      const vm = this
      vm.$refs.excelUploadResultWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
    },
    onClickClose () {
      const vm = this
      vm.isReadyToUpload = false
      const fileList = document.querySelector('.k-upload-sync ul')
      vm.removeFileList(fileList)
    }

  },
  data: function() {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      file: [],
      workbookData: null,
      excelUploadResult: {},
      isReadyToUpload: false,
      uploadDataArray: [],
    }
  },
}
</script>
